import { boronClient, makeFormData } from "../../../api";
import { useBoronMutation } from "../../../hooks/http/useBoronMutation";
import { useUpdateStudentKartesCache } from "../../../hooks/http/useFetchStudentKartes";

export type PostKarteParams = {
  name: string;
  comment: string;
  karte_attachments_attributes?: File[];
  karte_image_attachments_attributes?: File[];
};

export const usePostStudentKarte = ({ studentId }: { studentId: string }) => {
  const { addKarteCache } = useUpdateStudentKartesCache();

  return useBoronMutation(
    async (params: PostKarteParams) =>
      await boronClient.POST("/api/v1/students/{student_id}/kartes", {
        params: { path: { student_id: studentId } },
        body: {
          karte: params,
        },
        bodySerializer: makeFormData,
      }),
    {
      onSuccess: ({ karte }) => {
        addKarteCache(studentId, karte);
      },
    },
  );
};
